/* eslint-disable linebreak-style */
import { Component } from '@angular/core';
import {
  IDepartament,
  IProvince,
  IDistrict,
  BRANCH_STORE_TTL_ES
} from '../../../branch-store.interface';
import { FormBuilder, Validators } from '@angular/forms';
import { BranchStoreService } from '../../../branch-store.service';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
@Component({
  selector: 'pg-branch-store-create',
  templateUrl: './branch-store-create.component.html'
})
export class BranchStoreCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  departments: IDepartament[];
  provinces: IProvince[];
  districts: IDistrict[];

  constructor(
    private fb: FormBuilder,
    private serviceBase: BranchStoreService
  ) {
    super(BRANCH_STORE_TTL_ES, serviceBase);
  }

  ngOnInit(): void {
    this.fg = this.fb.group({
      name: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ], //name: ['', [Validators.required,Validators.minLength(4)]],
      address: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      establishmentCode: [
        '',
        [Validators.required, Validators.minLength(2), Validators.maxLength(32)]
      ],
      departmentId: ['', [Validators.required]],
      provinceId: ['', [Validators.required]],
      districtId: ['', [Validators.required]]
    });
    this.departments = this.serviceBase.getDepartaments();
  }

  onSubmit() {
    this.createItem$(this.fg.value);
  }

  filterProvinces(departamentId) {
    this.fg.get('provinceId').reset();
    this.fg.get('districtId').reset();
    this.provinces = this.serviceBase.getProvinces(departamentId);
    this.districts = [];
  }

  filterDistricts(provinceId) {
    this.fg.get('districtId').reset();
    this.districts = this.serviceBase.getDistricts(provinceId);
  }

  ngOnDestroy() {
    this.fg.reset();
    this.provinces = [];
    this.districts = [];
  }
}
